import { Card, Radio } from 'antd';
import styled from 'styled-components';

export const CurrentValue = styled.div`
  color: rgba(255, 255, 255, 0.65);
  margin-top: -8px;
`;

export const CalculationTypeGroup = styled(Radio.Group)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;

  .ant-radio-button-wrapper {
    text-align: center;
  }
`;

export const OperationGroup = styled(Radio.Group)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
`;

export const OperationCard = styled.label<{ $selected: boolean }>`
  align-items: flex-start;
  background: ${({ $selected }) =>
    $selected ? 'rgba(22, 119, 255, 0.12)' : 'rgba(255, 255, 255, 0.02)'};
  border: 1px solid ${({ $selected }) => ($selected ? '#1677ff' : '#424242')};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  min-height: 72px;
  padding: 14px;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    border-color: #1677ff;
  }
`;

export const OperationCopy = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const OperationDescription = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
`;

export const SummaryCard = styled(Card)`
  background: rgba(255, 255, 255, 0.025);
  border-color: #424242;

  .ant-card-body {
    padding: 8px;
  }
`;

export const SummaryEquation = styled.div`
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  text-align: center;
`;

export const SummaryValue = styled.div<{ $highlight?: boolean }>`
  color: ${({ $highlight }) => ($highlight ? '#49d17d' : 'inherit')};
  font-size: 12px;
  font-weight: 600;
`;

export const SummaryLabel = styled.div<{ $highlight?: boolean }>`
  color: ${({ $highlight }) =>
    $highlight ? '#49d17d' : 'rgba(255, 255, 255, 0.45)'};
  font-size: 12px;
  margin-top: 2px;
`;

export const InstallmentGrid = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media (max-width: 520px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const InstallmentItem = styled.div<{ $warning: boolean }>`
  background: ${({ $warning }) =>
    $warning ? 'rgba(255, 77, 79, 0.08)' : 'rgba(255, 255, 255, 0.025)'};
  border: 1px solid ${({ $warning }) => ($warning ? '#ff4d4f' : '#303030')};
  border-radius: 6px;
  color: ${({ $warning }) => ($warning ? '#ff7875' : 'inherit')};
  padding: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const InstallmentCount = styled.div<{ $warning: boolean }>`
  color: ${({ $warning }) =>
    $warning ? '#ff7875' : 'rgba(255, 255, 255, 0.45)'};
  font-size: 10px;
  font-weight: 500;
`;

export const InstallmentValue = styled.div`
  font-size: 12px;
  font-weight: 500;
`;
